export const VIJAYANAGAR_WARDS = [
  { number: 82, name: "Attiguppe" },
  { number: 83, name: "Hampi Nagar" },
  { number: 84, name: "Hosahalli" },
  { number: 85, name: "Adi Chunchanagiri Ward" },
  { number: 86, name: "Vidyaranyanagara" },
  { number: 87, name: "K.P. Agrahara (Kempapura Agrahara)" },
  { number: 88, name: "Sangolli Rayanna Ward" },
  { number: 89, name: "Bapuji Nagara" },
  { number: 90, name: "Krishnadevaraya Ward" },
  { number: 91, name: "Gali Anjaneya Temple Ward" },
  { number: 92, name: "Muneshwara Block" },
  { number: 93, name: "Avalahalli" },
  { number: 94, name: "Deepanjali Nagara" },
];

export const wardSlug = (name) =>
  name
    .toLowerCase()
    .replace(/\([^)]*\)/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const CIVIC_CATEGORIES = [
  "Roads & Potholes",
  "Water Supply",
  "Drainage",
  "Garbage & Waste",
  "Street Lights",
  "Parks & Public Spaces",
  "Schools",
  "Health Services",
  "Traffic & Parking",
  "Stray Animals",
  "Encroachment",
  "Sanitation",
  "Other",
];

export const CIVIC_CATEGORIES_KN = [
  "ರಸ್ತೆಗಳು ಮತ್ತು ಗುಂಡಿಗಳು",
  "ನೀರು ಸರಬರಾಜು",
  "ಚರಂಡಿ",
  "ಕಸ ಮತ್ತು ತ್ಯಾಜ್ಯ",
  "ಬೀದಿ ದೀಪಗಳು",
  "ಉದ್ಯಾನಗಳು ಮತ್ತು ಸಾರ್ವಜನಿಕ ಸ್ಥಳಗಳು",
  "ಶಾಲೆಗಳು",
  "ಆರೋಗ್ಯ ಸೇವೆಗಳು",
  "ಸಂಚಾರ ಮತ್ತು ಪಾರ್ಕಿಂಗ್",
  "ದಾರಿತಪ್ಪಿದ ಪ್ರಾಣಿಗಳು",
  "ಅತಿಕ್ರಮಣ",
  "ನೈರ್ಮಲ್ಯ",
  "ಇತರೆ",
];
